/**
 * Microsoft 365 grounding for the memory (docs/microsoft-365.md; AIOE-only, not the mirrored
 * microsoft365.ts): when a person asks the
 * organisation's memory a question, AIOE also asks Microsoft 365 Copilot through Work IQ's Chat
 * API, on that person's behalf, and shows the cited answer as its own section. Nothing from
 * Microsoft 365 is copied into AIOE's index; Microsoft's permissions and sensitivity labels apply;
 * Microsoft bills the question in Copilot Credits. Enterprise edition only.
 *
 *   GET  /memory/v1/microsoft365            whether it is on and ready (any signed-in person)
 *   PUT  /admin/v1/memory/microsoft365      { enabled } (administrators)
 *   POST /memory/v1/microsoft365            { question, conversationId?, timeZone? } → the answer, cited
 *
 * The person's AIOE sign-in is exchanged (OAuth on-behalf-of, by the API's own Entra app) for a
 * Work IQ token with the delegated permission WorkIQAgent.Ask; no token is kept beyond its life.
 */
import { z } from "zod";
/** Work IQ's application id in Entra: `az ad sp create --id` provisions it in a tenant. */
export const WORK_IQ_APP_ID = "fdcc1f02-fc51-4226-8753-f668596af7f7";
export const WORK_IQ_ASK_PERMISSION_ID = "0b1715fd-f4bf-4c63-b16d-5be31f9847c2";
/** A GUID, as Entra writes an application (client) id. */
const clientIdSchema = z.string().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, "an application (client) id is a GUID");
/**
 * `PUT /admin/v1/memory/microsoft365`: either or both. `workbenchClientId` is the public client AI
 * Workbench signs people in to Microsoft 365 with (Work IQ as a tool server), served in discovery as
 * `microsoftSignIn`; null takes it away.
 */
export const microsoft365GroundingSettingsSchema = z
    .object({ enabled: z.boolean().optional(), workbenchClientId: clientIdSchema.nullable().optional() })
    .refine((v) => v.enabled !== undefined || v.workbenchClientId !== undefined, "say whether it is enabled, or which app AI Workbench signs in with");
export const microsoft365AskSchema = z.object({
    question: z.string().trim().min(1).max(4000),
    /** Continue a conversation an earlier answer named. */
    conversationId: z.string().min(1).max(200).optional(),
    /** An IANA time zone, for questions about "today" and "tomorrow". */
    timeZone: z.string().min(1).max(100).optional(),
});
//# sourceMappingURL=memoryGrounding.js.map